/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
import Glide from '@glidejs/glide';

const mobileSliders = () => {
  /**
   * Activities carousel (main page)
   */
  const homeSlider = document.querySelectorAll('.js-main-topics-mobile-slider');
  if (homeSlider) {
    homeSlider.forEach(carousel => {
      const glide = new Glide(carousel, {
        autoplay: 5000,
        type: 'slider',
        bound: true,
        startAt: 0,
        perView: 1,
        gap: 20,
        autoheight: true,
      });
      glide.mount();
    });
  }

  // const mobileNav = document.querySelector('.js-select-mobile-nav');
  // const sliderRelated = document.querySelectorAll(
  //   '.js-mobile-slider-related-post',
  // );
  // const mq = window.matchMedia('(min-width: 768px)');

  // if (sliderRelated) {
  //   sliderRelated.forEach(carousel => {
  //     let glide;
  //     let isMount = false;

  //     function init() {
  //       if (mq.matches && isMount) {
  //         glide.destroy();
  //         isMount = false;
  //       }

  //       if (!mq.matches && !isMount) {
  //         glide = new Glide(carousel, {
  //           autoplay: 5000,
  //           type: 'slider',
  //           bound: true,
  //           startAt: 0,
  //           perView: 1,
  //           gap: 20,
  //           autoheight: true,
  //         });
  //         glide.mount();
  //         isMount = true;
  //       }

  //       if (mobileNav) {
  //         mobileNav.addEventListener('change', () => {
  //           glide.update();
  //         });
  //       }
  //     }

  //     window.addEventListener('resize', init);
  //     init();
  //   });
  // }
};
export default mobileSliders;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/mobileSliders.js